import { Box, Button, Card } from '@energiebespaarders/symbols';
import { Heading, Small } from '@energiebespaarders/symbols/helpers';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { margin, padding } from '~/styles/mixins';
import type { getAllTopics_allFaqTopics } from '~/types/generated/cms/getAllTopics';
import type { getCategories_allFaqCategories } from '~/types/generated/cms/getCategories';

interface Props {
  category: getCategories_allFaqCategories;
  topics: getAllTopics_allFaqTopics[];
}

const StyledTopicLink = styled(Box)`
  ${padding(2)};
  cursor: pointer;
  font-weight: 400;
  border-bottom: 1px solid ${x => x.theme.colors.grayLight};

  &:last-of-type {
    border-bottom: 0;
    ${margin(2, 'b')};
  }

  &:hover {
    background: ${x => x.theme.colors.grayLighter};
  }
`;

const CategoryCard: React.FC<Props> = ({ category, topics }) => {
  const renderedTopics = topics?.slice(0, 5);
  const router = useRouter();
  return (
    <Card p={3} style={{ flexDirection: 'column', width: '100%' }}>
      <Heading heading="h2" style={{ margin: 0 }}>
        <Small>{category.title}</Small>
      </Heading>

      {renderedTopics.map(t => (
        <StyledTopicLink
          key={t.id}
          display="flex"
          alignItems="center"
          onClick={() => router.push(`/faq/${t.category?.slug}/${t.slug}`)}
        >
          {t.title}
        </StyledTopicLink>
      ))}

      <Button
        to={`/faq/${category.slug}`}
        fluid
        inverse
        title="Alle artikelen"
        label="Alle artikelen"
        mb={0}
        style={{ minHeight: 0 }}
      />
    </Card>
  );
};

export default CategoryCard;
